import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { getImageData } from '../../modules/traffic-analisys/operations';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface PhotoDialogProps {
  open: boolean;
  base64Photo: string;
  onClose: () => void;
}

export default function PhotoDialog({ open, onClose, base64Photo }: PhotoDialogProps) {
  const [base64, setBase64] = React.useState<string>('');
  React.useEffect(() => {
    const fetchData = async () => {
      if (base64Photo && base64Photo.length > 0) {
        const result = await getImageData(base64Photo);
        setBase64(String(result));
      } else {
        setBase64(base64Photo);
      }
    };
    fetchData();
  }, [base64Photo]);

  return (
    <div>
      <Dialog open={open} TransitionComponent={Transition} keepMounted onClose={onClose} aria-describedby="alert-dialog-slide-description">
        <DialogTitle>Podgląd</DialogTitle>
        <DialogContent>
          <img src={base64} width="100%" alt="zdjecie tablicy rejestracyjnej" />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Zamknij</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
